import fetch from './api'

// 获取学员回答信息
const GETSTUQUESTION = params => {
    return fetch({
        url: '/api/admin/ask/getAskInfo',
        method: 'get',
        params
    })
}
// 将学员问题置为无效
const MARKINVAILD = params => {
  return fetch({
      url: '/api/admin/ask/markInvaild',
      method: 'get',
      params
  })
}
// 释放问题
const ABANDONREPLAY = params => {
  return fetch({
      url: '/api/admin/ask/abandonReplay',
      method: 'get',
      params
  })
}
// 保存回复的答疑内容
const SAVEASKREPLAY = params => {
  return fetch({
      url: '/api/admin/ask/saveAskReplay',
      method: 'post',
      data: params
  })
}

// 获取画布提问内容
const GETASKCANVASINFO = params => {
  return fetch({
      url: '/api/admin/ask/getAskCanvasInfo',
      method: 'get',
      params
  })
}

// 保存画布答疑内容
const SAVEASKCANVASINFO = params => {
  return fetch({
      url: '/api/admin/ask/saveAskCanvasInfo',
      method: 'post',
      data: params
  })
}
export default {
    GETSTUQUESTION,
    MARKINVAILD,
    ABANDONREPLAY,
    SAVEASKREPLAY,
    GETASKCANVASINFO,
    SAVEASKCANVASINFO
}



// WEBPACK FOOTER //
// ./src/api/interface-dayi.js